export default function guard(to, from, next) {
    let isAuthenticated = !! ( localStorage.getItem('user-token') || '' )
    if(to.path === "/login") {
        // send user to root path if already is authenticated
        if(isAuthenticated) {
            next('/')
			return
        }
    }
    else { // user isn't visiting auth views and user want to go to dashboard 
        let token = getLoginToken_FromParams()
        if(! isAuthenticated && token === undefined) {
            console
            next('/login')
            return
        }
    } // end if-else

    next()
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getLoginToken_FromParams = () => {
    try {
        return window.location.search.substr(1).split('=')[1];
    } catch (err) {
        return undefined
    }
    
} // end function
